module.exports = __webpack_public_path__ + "img/Logo-Tourisme-Handicap.778f8d21.jpg";